export default {
    ja: {
        tickets2: {
            ticket_type: 'セットチケット',
            headers: ['', '', '中高生以上'],
            title: 'NAKEDディスタンス提灯®レンタルセットチケット',
            rows: [
                {
                    dayType: '金土日祝',
                    prices: [
                        { type: '早割', adultPrice: '2,500円' },
                        { type: '通常', adultPrice: '2,700円' }
                    ]
                }
            ],
            agency: {
                title: 'チケット購入',
                sold_out: '販売終了しました',
                sp: 'スマホで発券したい方',
                cv: 'コンビニで発券したい方',
                items: [
                    {
                        type: 'heading',
                        text: 'スマホで発券したい方'
                    },
                    {
                        type: 'button',
                        text: 'チケット購入はこちら',
                        link: 'https://www.kkday.com/ja/product/195567?cid=13044&ud1=officialwebsite',
                        class: '',
                        disabled: false
                    },
                ]
            },
            notice: {
                caption: '※事前申込、日時指定（各日先着200枚限定）\n'+
                '※小学生料金とのセットチケット販売はありません。',
            },
        },
    },
    en: {
        tickets2: {
            heading: 'TICKETS',
            ticket_type: 'Combo Ticket',
            headers: ['', '', 'Middle School Students<br>or Above'],
            title: 'NAKED Distance Lantern® Rental Set Ticket',
            rows: [
                {
                    dayType: 'Fri.~ Sun. Holidays',
                    prices: [
                        { type: 'Early bird tickets', adultPrice: '2,500JPY' },
                        { type: 'Regular admission tickets', adultPrice: '2,700JPY' }
                    ]
                }
            ],
            agency: {
                title: 'Ticket purchase',
                sold_out: 'Sold Out',
                items: [
                    {
                        type: 'heading',
                        text: 'Issue a smartphone ticket'
                    },
                    {
                        type: 'button',
                        text: 'Ticket purchase',
                        link: 'https://www.kkday.com/ja/product/195567?cid=13044&ud1=officialwebsite',
                        class: '',
                        disabled: false
                    },
                ]
            },
            notice: {
                title: 'Important notes',
                caption: '*Pre-registration, date and time to be determined (limited to the first 200 tickets for each day)\n'+
                '*No set ticket sales with elementary school student fee.',
            },
        },
    },
    zhTW: {
        tickets2: {
            heading: '門票',
            ticket_type: '早鳥票',
            description: '入場費用+1杯歡迎飲料和1份甜點或小食\n' + '（*不包括炒麵）\n' + '包含生啤暢飲！',
            headers: ['', '', '中學生以上', '小學生'],
            rows: [
                {
                    dayType: '週一至週四',
                    prices: [
                        { type: '早鳥', adultPrice: '3,800日元', childPrice: '3,400日元' },
                        { type: '普通', adultPrice: '3,900日元', childPrice: '3,500日元' }
                    ]
                },
                {
                    dayType: '週五、週六、週日及節假日',
                    prices: [
                        { type: '早割', adultPrice: '3,900日元', childPrice: '3,500日元' },
                        { type: '通常', adultPrice: '4,000日元', childPrice: '3,700日元' }
                    ]
                }
            ],
            agency: {
                title: '購票',
                sold_out: '販売終了しました',
                sp: '手機購票的旅客',
                cv: '',
                items: [
                    {
                        type: 'heading',
                        text: '手機購票的旅客'
                    },
                    {
                        type: 'button',
                        text: 'KKday',
                        link: 'https://www.kkday.com/en/product/182733?cid=15009&ud1=officialsite',
                        class: '',
                        disabled: false
                    },
                    {
                        type: 'button',
                        text: 'Klook',
                        link: 'https://www.klook.com/zh-TW/activity/122045-naked-omatsuri-eat-play-and-dance-marun[%E2%80%A6]/?spm=Activity.TopNavigation.SelectLanguage&clickId=3176dcc303',
                        class: '',
                        disabled: false
                    },
                ]
            },
            notice: {
                title: '注意事項',
                caption: '※ 學齡前兒童免費入場。\n' +
                    '※ 早鳥票銷售截止日期為7月25日（週四）23:59。\n' +
                    '※ 現場也將銷售普通門票。但根據擁擠情況，可能會限制現場普通門票的銷售。敬請諒解。\n' +
                    '※ 可在TicketPia、Asoview、KKday、Klook購買門票。\n' +
                    '※ 除非因主辦方原因暫停或取消，否則門票不可退款或更改。\n' +
                    '※ 根據擁擠情況，可能會限制入場人數。\n' +
                    '※ 本活動最後入場時間為21:30。根據入場等候隊列情況，可能會在21:30前結束入場接待。在此情況下，即使持有入場券，也無法入場，敬請諒解。\n' +
                    '※ 請勿在會場內使用單腳架或三腳架。\n' +
                    '※ 不允許攜帶寵物入場。\n' +
                    '※ 會場內可能有額外收費的內容。',
            },
        },
    },
    zhCN: {
        tickets2: {
            heading: '门票',
            ticket_type: '早鸟票',
            description: '入场费用+1杯欢迎饮料和1份甜点或小食\n' + '（*不包括炒面）\n' + '包含生啤畅饮！',
            headers: ['', '', '中学生以上', '小学生'],
            rows: [
                {
                    dayType: '周一至周四',
                    prices: [
                        { type: '早鸟', adultPrice: '3,800日元', childPrice: '3,400日元' },
                        { type: '普通', adultPrice: '3,900日元', childPrice: '3,500日元' }
                    ]
                },
                {
                    dayType: '周五、周六、周日及节假日',
                    prices: [
                        { type: '早鸟', adultPrice: '3,900日元', childPrice: '3,500日元' },
                        { type: '通常', adultPrice: '4,000日元', childPrice: '3,700日元' }
                    ]
                }
            ],
            agency: {
                title: '购票',
                sold_out: '販売終了しました',
                sp: '手机购票的旅客',
                cv: '',
                items: [
                    {
                        type: 'heading',
                        text: '手机购票的旅客'
                    },
                    {
                        type: 'button',
                        text: 'KKday',
                        link: 'https://www.kkday.com/en/product/182733?cid=15009&ud1=officialsite',
                        class: '',
                        disabled: false
                    },
                    {
                        type: 'button',
                        text: 'Klook',
                        link: 'https://www.klook.com/zh-CN/activity/122045-naked-omatsuri-eat-play-and-dance-marun[%E2%80%A6]/?spm=Activity.TopNavigation.SelectLanguage&clickId=c3cbe227ce',
                        class: '',
                        disabled: false
                    },
                ]
            },
            notice: {
                title: '注意事项',
                caption: '※ 学龄前儿童免费入场。 \n' +
                    '※ 早鸟票销售截止日期为7月25日（周四）23:59。 \n' +
                    '※ 现场也将销售普通门票。但根据拥挤情况，可能会限制现场普通门票的销售。敬请谅解。 \n' +
                    '※ 可在TicketPia、Asoview、KKday、Klook购买门票。 \n' +
                    '※ 除非因主办方原因暂停或取消，否则门票不可退款或更改。 \n' +
                    '※ 根据拥挤情况，可能会限制入场人数。 \n' +
                    '※ 本活动最后入场时间为21:30。根据入场等候队列情况，可能会在21:30前结束入场接待。在此情况下，即使持有入场券，也无法入场，敬请谅解。 \n' +
                    '※ 请勿在会场内使用单脚架或三脚架。 \n' +
                    '※ 不允许携带宠物入场。 \n' +
                    '※ 会场内可能有额外收费的内容。',
            },
        },
    },
    ko: {
        tickets2: {
            heading: '티켓',
            ticket_type: '조기 할인 티켓',
            description: '입장료＋웰컴 드링크 1잔＆스위트 또는 푸드\n' + '(※야키소바 제외) 1종\n' + '생맥주 무한 리필 포함!',
            headers: ['', '', '중학생 이상', '초등학생'],
            rows: [
                {
                    dayType: '월〜목',
                    prices: [
                        { type: '사전구매', adultPrice: '3,800엔', childPrice: '3,400엔' },
                        { type: '일반', adultPrice: '3,900엔', childPrice: '3,500엔' }
                    ]
                },
                {
                    dayType: '금토일공휴일',
                    prices: [
                        { type: '사전구매', adultPrice: '3,900엔', childPrice: '3,500엔' },
                        { type: '일반', adultPrice: '4,000엔', childPrice: '3,700엔' }
                    ]
                }
            ],
            agency: {
                title: '티켓 구매',
                sold_out: '販売終了しました',
                sp: '스마트폰으로 티켓 발권하기',
                cv: '',
                items: [
                    {
                        type: 'heading',
                        text: '스마트폰으로 티켓 발권하기'
                    },
                    {
                        type: 'button',
                        text: 'KKday',
                        link: 'https://www.kkday.com/en/product/182733?cid=15009&ud1=officialsite',
                        class: '',
                        disabled: false
                    },
                    {
                        type: 'button',
                        text: 'Klook',
                        link: 'https://www.klook.com/en-US/activity/122045-naked-omatsuri-eat-play-and-dance-marunouchi-tokyo/',
                        class: '',
                        disabled: false
                    },
                ]
            },
            notice: {
                title: '주의 사항',
                caption: '※미취학 아동 무료입장.\n' +
                    '※얼리버드 티켓은 7월 25일(목) 23:59까지 판매됩니다.\n' +
                    '※현장에서도 일반 티켓을 판매합니다. 다만, 혼잡 상황에 따라 현장에서 일반 티켓 판매를 제한할 수 있으니 양해 부탁드립니다.\n' +
                    '※티켓은 Ticket Pia, Asoview, KKday, Klook 에서 구매 가능합니다.\n' +
                    '※주최 측 사정으로 인해 중지 또는 취소된 경우를 제외하고 티켓의 환불 및 변경은 불가합니다.\n' +
                    '※혼잡 상황에 따라 입장이 제한될 수 있습니다.\n' +
                    '※본 이벤트는 21:30 최종 입장입니다. 입장 대기 줄 상황에 따라 21:30 이전에 접수를 종료할 수 있습니다. 이 경우, 입장권을 소지하셔도 입장할 수 없으니 양해 부탁드립니다.\n' +
                    '※장내에서는 일각대 및 삼각대 사용은 삼가 주세요.\n' +
                    '※반려동물 동반 불가.\n' +
                    '※장내에는 별도의 유료 콘텐츠가 있습니다.',
            },
        },
    }
};

